import React from "react";

import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";

import "./search-input.styles.css";
import { useSearchInput } from "./hooks/useSearchInput";

const SearchInput = ({ onSearch }) => {
  const {
    textToSearch,
    handleChangeSearchText,
    onClickToSearch,
    handleKeyDown,
  } = useSearchInput(onSearch);
  return (
    <div className="search-input-new">
      <button className="search-input-new__btn" onClick={onClickToSearch}>
        <Search />
      </button>
      <input
        value={textToSearch}
        onChange={handleChangeSearchText}
        onKeyDown={handleKeyDown}
        type="text"
        placeholder="Pesquisar"
      />
    </div>
  );
};

export default SearchInput;
